<ng-container *ngIf="!term_control.control.isMultiSelectControl() && custom_control_values.length > 0">
  <ng-container *ngFor="let custom_control_value of custom_control_values; let i = index">
    {{custom_control_value.value.id ? custom_control_value.value.output_text?.toLocaleLowerCase()  : custom_control_value.output_text?.toLocaleLowerCase()}}
    <span style="margin-left: -4px" *ngIf="i != custom_control_values.length - 1">,</span>
  </ng-container>
</ng-container>
<ng-container *ngIf="term_control.control.isMultiSelectControl() && custom_control_values.length > 0">
  {{custom_control_values[0].value.id ? custom_control_values[0].value.output_text?.toLocaleLowerCase()  : custom_control_values[0].output_text?.toLocaleLowerCase()}}
</ng-container>
